.core-notification-pill {
  display: inline-flex;
  justify-content: center;
}

.core-notification-pill.notification-pill--empty {
  padding: var(--number-spacing-4xsmall);
}

.core-notification-pill .notification-pill-wrapper {
  display: inline-flex;
  justify-content: center;
  border-radius: var(--number-radius-round);
  padding: 0 var(--number-spacing-4xsmall);
  background-color: var(--color-status-background-error-accent);
  color: var(--color-status-content-all-accent);
  min-width: calc(1rem - (var(--number-spacing-4xsmall) * 2)) /* make sure the pill is round even at the minimum width possible */
}

.core-notification-pill.notification-pill--empty .notification-pill-wrapper {
  width: 0.5rem;
  height: 0.5rem;
  padding: 0;
  background-color: var(--color-status-content-error);
}
